import { createContext, CSSProperties, ReactNode, useContext } from 'react';

export type WhilelabelContextType = {
  companyName?: string;
  pixelName?: string;
  primaryColor?: string;
  companyLogo?: ReactNode;
  primaryButtonStyle?: CSSProperties;
  secondaryButtonStyle?: CSSProperties;
  isWhitelabelCompany?: boolean;
  supportEmail?: string;
  companyHash?: string;
  getCompanyConfig?: (
    companyId?: number,
    companyHash?: string,
  ) => WhilelabelContextType;
};

export const WhitelabelContext = createContext({} as WhilelabelContextType);

export const useWhitelabelConfig = () => useContext(WhitelabelContext);
